import { useEffect, useState} from 'react'
import { GetAppointmentByIdOutput } from '../../../../Adaptor/TUBSIS/controllers/Appointments/models/getAppointmentModels'
import React from 'react'
import moment from 'moment'
import { deleteAppointment, getAppointmentsByExpertId, getUsersByUserGroup } from '../../../../Adaptor/TUBSIS'
import { GetUsersByUserGroupOutput } from '../../../../Adaptor/TUBSIS/controllers/UserGroups/models/getUserGroupModels'
import AppointmentCreate from './AppointmentCreate'
import AppointmentUpdate from './AppointmentUpdate'

// type Props = {appointments: GetAppointmentByIdOutput[]}

const AppointmentTable= /*React.FC<Props> = ({ appointments })*/() => { 
  
    const [expertList, setExpertList] = useState<GetUsersByUserGroupOutput[] | null>(null)
    const [selectedExpert, setSelectedExpert] = useState<GetUsersByUserGroupOutput | null>(null)
    useEffect(() => {
      getUsersByUserGroup(4)//get experts
        .then((response) => {
          ////debugger
          //console.log("expertList",response.data)
          setExpertList(response.data)
        })
        .catch((error) => {
          ////debugger
          console.log(error)
        })
    }, [])

    useEffect(() => {
        // Eğer expertList boş değilse ve en az bir uzman varsa
        if (expertList && expertList.length > 0) {
            // İlk uzmanı seç
            setSelectedExpert(expertList[0]);
        }
    }, [expertList]);
    
  const [appointmentList, setAppointmentList] = useState<GetAppointmentByIdOutput[] | null>(null)
//   const [selectedAppointment, setSelectedAppointment] = useState<GetAppointmentByIdOutput | null>(null)
  useEffect(() => {
    // Eğer seçili uzman varsa randevuları yükle
    if (selectedExpert) {
        getAppointmentsByExpertId(selectedExpert?.userId ?? -1)
            .then((response) => {
                setAppointmentList(response.data);
            })
            .catch((error) => {
                console.error("Error fetching appointments:", error);
            });
    }
}, [selectedExpert]);

//   const handleExpertChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
//     const selectedExpertId = parseInt(event.target.value)
//     const selectedExpert = expertList?.find(expert => expert.userId === selectedExpertId) ?? null
//     setSelectedExpert(selectedExpert)
// }

const handleDeleteClick = (appointmentId: number) => {
    // Silme işlemine başlamadan önce kullanıcıyı uyaralım
    const isConfirmed: boolean = window.confirm("Randevuyu silmek istiyor musunuz?");

    // Eğer kullanıcı silmeyi onaylarsa devam edelim
    if (isConfirmed) {
        // Silme işlemini gerçekleştir
        deleteAppointment(appointmentId)
        .then((response) => {
          ////debugger
          //console.log("delete",response.data)

          // Silinecek randevuyu filtrele
          const updatedAppointments = appointmentList?.filter(appointment => appointment.appointmentId !== appointmentId);
            
          // Güncellenmiş randevu listesini state'e uygula
          setAppointmentList(updatedAppointments??[]);
        })
        .catch((error) => {
          ////debugger
          console.log(error)
        })
    }
};

    return (
        <div className='card p-5'>
            <div className='card-header'>
                <div className='d-flex align-items-center'>
                    {/* <label htmlFor="userSelect" className="col-form-label text-start me-2 fw-bold text-gray-500">Uzman Seçiniz:</label>
                    <select
                        id="userSelect"
                        title='Uzman Seçiniz'
                        className="form-select form-select-sm fw-bold text-hover-primary text-gray-600"
                        value={selectedExpert?.userId ?? ''}
                        onChange={handleExpertChange}
                    >
                        {expertList?.map((expert) => (
                            <option key={expert.userId} value={expert.userId}>
                                {expert.fullName}
                            </option>
                        ))}
                    </select> */}
                </div>
                <AppointmentCreate appointmentStartDate={null}/>
            </div>
            <div className='card-body'> 
                <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                    {/* <!--begin::Table head--> */}
                    <thead>
                        <tr className="fw-bold text-gray-600">
                            <th className="w-25px">
                                <div className="form-check form-check-sm form-check-custom form-check-solid">
                                    <input className="form-check-input" type="checkbox" value="1" data-kt-check="true" data-kt-check-target=".widget-9-check"/>
                                </div>
                            </th>
                            {/* <th className="min-w-200px">Uzman</th> */}
                            <th className="min-w-150px">TC Kilmik No</th>
                            <th className="min-w-150px">Danışan</th>
                            <th className="min-w-150px">Telefon Numarası</th>
                            <th className="min-w-150px">Görüşme Tarihi</th>
                            <th className="min-w-150px">Randevu Tipi</th>
                            <th className="min-w-100px text-end">İşlemler</th>
                        </tr>
                    </thead>
                    {/* <!--end::Table head--> */}

                    {/* table body began */}

                    {appointmentList && appointmentList.length > 0 ? (
                    <tbody>
                        {appointmentList.map((appointment, index) => (
                            <tr key={index}>
                                <td>
                                    <div className="form-check form-check-sm form-check-custom form-check-solid">
                                        <input className="form-check-input widget-9-check" type="checkbox" value="1"/>
                                    </div>
                                </td>
                                
                                {/* <td>
                                    <div className="d-flex align-items-center">
                                        <div className="d-flex justify-content-start flex-column">
                                            <span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{appointment.expertFullName}</span>
                                        </div>
                                    </div>                                
                                </td> */}
                                
                                <td>
                                    <div className="d-flex align-items-center">
                                        <div className="d-flex justify-content-start flex-column">
                                            <span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{appointment.patientCitizienId}</span>{/*TCKimlikNo*/}
                                        </div>
                                    </div>                                
                                </td>

                                <td>
                                    <span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{appointment.patientFullName}</span>
                                </td>
                                
                                <td>
                                    <div className="d-flex align-items-center">
                                        <div className="d-flex justify-content-start flex-column">
                                            <span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{appointment.patientPhoneNumber}</span>{/*TelefonNo*/}
                                        </div>
                                    </div>                                
                                </td>

                                <td className="text-end">
                                    <div className="d-flex flex-column w-100 me-2">
                                        <div className="d-flex flex-stack mb-2">
                                            <span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">
                                                {moment(appointment.appointmentStartDate).format('DD MMMM YYYY HH:mm')}
                                            </span>
                                        </div>
                                    </div>
                                </td>

                                {/* <td className="text-end">
                                    <div className="d-flex flex-column w-100 me-2">
                                        <div className="d-flex flex-stack mb-2">
                                            <span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">
                                                {moment(appointment.appointmentEndDate).format('DD MMMM YYYY HH:mm')}
                                            </span>
                                        </div>
                                    </div>
                                </td> */}
                                
                                <td className="text-end">
                                    <div className="d-flex flex-column w-100 me-2">
                                        <div className="d-flex flex-stack mb-2">
                                            <h3> 
                                                {appointment.isFirstAppointment ? 
                                                <span className="badge badge-primary" style={{fontSize:"1.1rem"}}>YENİ</span> : 
                                                <span className="badge badge-secondary" style={{fontSize:"1.1rem"}}>KONTROL</span>
                                                }
                                            </h3>
                                                
                                        </div>
                                    </div>
                                </td>

                                <td>
                                    <div className="d-flex justify-content-end flex-shrink-0">
                                        {/* <a href="#" className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                                            <i className="ki-duotone ki-switch fs-2"><span className="path1"></span><span className="path2"></span></i>                                    
                                        </a> */}
                                        
                                        {/* <a href="#" className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                                            <i className="ki-duotone ki-pencil fs-2"><span className="path1"></span><span className="path2"></span></i>                                    
                                        </a> */}

                                        <AppointmentUpdate appointment={appointment}/>

                                        <button 
                                            type="button" 
                                            title='Randevuyu Sil'
                                            className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm" 
                                            onClick={() => handleDeleteClick(appointment.appointmentId)}>
                                            <i className="ki-duotone ki-trash fs-2"><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span></i>                                    
                                        </button>

                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>)
                : (
                    <tbody>
                        <tr>
                            <td>
                                <div className="form-check form-check-sm form-check-custom form-check-solid">
                                    <input className="form-check-input widget-9-check" type="checkbox" value="1" disabled/>
                                </div>
                            </td>
                            <td>
                                <div className="d-flex align-items-center">
                                    <div className="d-flex justify-content-start flex-column">
                                        <span className="text-gray-400 fw-bold text-hover-primary d-block fs-6">RANDEVU BULUNAMADI.</span>
                                    </div>
                                </div>     
                                {/* <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                                    <div className="fs-3 text-muted">Randevu Bulunamadı.</div>
                                </div> */}
                            </td>
                        </tr>
                    </tbody>)}
                </table>
            </div>
      </div>
    )
}

export default (AppointmentTable)